import type { FC } from 'react';
import SearchHero, { type SearchHeroProps } from 'src/common/components/Search/SearchHero';
import classNames from 'classnames/bind';
import { useSearchHeroVisibilityContext } from '../SearchHeroVisibilityProvider';
import styles from './SearchNav.module.scss';

const cx = classNames.bind(styles);
export type SearchNavProps = {
  hideWhenHeroVisible?: boolean;
  theme: SearchHeroProps['theme'];
};

const SearchNav: FC<SearchNavProps> = ({ hideWhenHeroVisible, theme }) => {
  const { heroInView } = useSearchHeroVisibilityContext();
  const animate = hideWhenHeroVisible;
  const show = heroInView === false || !animate;

  return (
    <div className={cx(styles.root, { show })}>
      <div className={cx(styles.container, { show, animate })}>
        <SearchHero variant="navigation" theme={theme} />
      </div>
    </div>
  );
};

export default SearchNav;
